export const CancellationAction = {
  NO_ACTION: 'NO_ACTION',
  CANCEL: 'CANCEL',
  REQUEST_TO_CANCEL: 'REQUEST_TO_CANCEL'
};